(function () {
  if (window.__currencySwitcherInit) return;
  window.__currencySwitcherInit = true;

  var CACHE_KEY = 'cp_fx_rates_v2';
  var CACHE_EXPIRY = 'cp_fx_expiry_v2';
  var ONE_HOUR = 3600000;
  var PREF_KEY = 'preferred_currency';

  var LABELS = { USD: 'Dolar', BRL: 'Real', PYG: 'Guarani' };

  function getPreferred() {
    try {
      return localStorage.getItem(PREF_KEY) || 'USD';
    } catch (e) {
      return 'USD';
    }
  }

  function setPreferred(code) {
    try {
      localStorage.setItem(PREF_KEY, code);
    } catch (e) {}
  }

  function manualRates() {
    if (!window.__manualRatesEnabled) return null;
    var brl = parseFloat(window.__manualRateBRL);
    var pyg = parseFloat(window.__manualRatePYG);
    if (isNaN(brl) || isNaN(pyg)) return null;
    return { BRL: brl, PYG: pyg };
  }

  function fetchRates() {
    var manual = manualRates();
    if (manual) return Promise.resolve(manual);

    var stored, expiry;
    try {
      stored = localStorage.getItem(CACHE_KEY);
      expiry = localStorage.getItem(CACHE_EXPIRY);
    } catch (e) {}
    if (stored && expiry && Date.now() < parseInt(expiry, 10)) {
      return Promise.resolve(JSON.parse(stored));
    }
    return fetch('https://open.er-api.com/v6/latest/USD')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var rates = { BRL: data.rates.BRL, PYG: data.rates.PYG };
        try {
          localStorage.setItem(CACHE_KEY, JSON.stringify(rates));
          localStorage.setItem(CACHE_EXPIRY, String(Date.now() + ONE_HOUR));
        } catch (e) {}
        return rates;
      });
  }

  function formatPrice(cents, code, rates) {
    var usd = cents / 100;
    if (code === 'BRL' && rates) {
      var brl = usd * rates.BRL;
      try {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(brl);
      } catch (e) {
        return 'R$ ' + brl.toFixed(2).replace('.', ',');
      }
    }
    if (code === 'PYG' && rates) {
      var pyg = usd * rates.PYG;
      try {
        return '₲ ' + new Intl.NumberFormat('es-PY', { maximumFractionDigits: 0 }).format(pyg);
      } catch (e) {
        return '₲ ' + Math.round(pyg).toLocaleString();
      }
    }
    return '$' + usd.toFixed(2);
  }

  function formatRate(code, rates) {
    if (code === 'USD' || !rates) return '$ 1,00';
    if (code === 'BRL') return 'R$ ' + rates.BRL.toFixed(2).replace('.', ',');
    if (code === 'PYG') return '₲ ' + Math.round(rates.PYG).toLocaleString('es-PY');
    return '';
  }

  function applyToPage(code, rates) {
    document.querySelectorAll('[data-price-cents]').forEach(function (el) {
      var cents = parseInt(el.getAttribute('data-price-cents'), 10);
      if (isNaN(cents)) return;
      el.textContent = formatPrice(cents, code, rates);
    });

    document.querySelectorAll('[data-currency-rate-display]').forEach(function (el) {
      el.textContent = formatRate(code, rates);
    });

    document.querySelectorAll('[data-currency-label]').forEach(function (el) {
      el.textContent = LABELS[code] || code;
    });

    document.querySelectorAll('[data-currency-option]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.currencyOption === code);
    });
  }

  function init() {
    var rates = null;
    var applying = false;

    function reapply() {
      applying = true;
      applyToPage(getPreferred(), rates);
      Promise.resolve().then(function () {
        applying = false;
      });
    }

    fetchRates()
      .then(function (r) {
        rates = r;
        reapply();
      })
      .catch(function () {
        reapply();
      });

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-currency-toggle]');
      var menu = document.querySelector('[data-currency-menu]');

      if (toggle) {
        event.stopPropagation();
        if (menu) menu.toggleAttribute('hidden');
        return;
      }

      var option = event.target.closest('[data-currency-option]');
      if (option) {
        setPreferred(option.dataset.currencyOption);
        reapply();
        if (menu) menu.setAttribute('hidden', '');
        return;
      }

      if (menu && !menu.hasAttribute('hidden') && !event.target.closest('[data-currency-switcher]')) {
        menu.setAttribute('hidden', '');
      }
    });

    var pending = false;
    var observer = new MutationObserver(function () {
      if (applying || pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        reapply();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
